import React, { useState } from 'react'
import { Form, Input, Button, Typography, Alert } from 'antd'
import { LockOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import { useHistory, useLocation } from 'react-router-dom'
import axios from 'axios'
import { serverUrl } from '../../Constants'

const { Title, Text } = Typography

function ResetPassword() {
    const history = useHistory()
    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const token = params.get('token') ?? ''
    const email = params.get('email') ?? ''

    const [loading, setLoading] = useState(false)
    const [done, setDone] = useState(false)
    const [apiError, setApiError] = useState<string | null>(null)

    const onFinish = async ({ password, password_confirmation }: any) => {
        setLoading(true)
        setApiError(null)
        try {
            await axios.post(`${serverUrl}auth/reset-password`, {
                token,
                email,
                password,
                password_confirmation,
            })
            setDone(true)
        } catch (err: any) {
            const msg = err?.response?.data?.msg ?? 'El enlace es inválido o ha expirado.'
            setApiError(msg)
        } finally {
            setLoading(false)
        }
    }

    if (!token || !email) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '80px' }}>
                <div style={{ width: '360px' }}>
                    <Alert
                        type="error"
                        message="Enlace inválido"
                        description="El enlace de recuperación es inválido o ha expirado. Solicita uno nuevo."
                    />
                    <Button
                        type="link"
                        icon={<ArrowLeftOutlined />}
                        style={{ paddingLeft: 0, marginTop: '16px' }}
                        onClick={() => history.push('/forgot-password')}
                    >
                        Solicitar nuevo enlace
                    </Button>
                </div>
            </div>
        )
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '80px' }}>
            <div style={{ width: '360px' }}>
                <Title level={4} style={{ marginBottom: '8px' }}>Nueva contraseña</Title>

                {done ? (
                    <>
                        <Alert type="success" message="Contraseña actualizada correctamente." style={{ marginBottom: '16px' }} />
                        <Text type="secondary" style={{ display: 'block', marginBottom: '16px' }}>
                            Ya puedes iniciar sesión con tu nueva contraseña.
                        </Text>
                        <Button
                            type="primary"
                            className="green"
                            style={{ width: '100%' }}
                            onClick={() => history.push('/')}
                        >
                            Ir al inicio de sesión
                        </Button>
                    </>
                ) : (
                    <>
                        <Text type="secondary" style={{ display: 'block', marginBottom: '24px' }}>
                            Elige una contraseña segura para tu cuenta <strong>{email}</strong>.
                        </Text>

                        {apiError && (
                            <Alert
                                type="error"
                                message={apiError}
                                style={{ marginBottom: '16px' }}
                                action={
                                    <Button size="small" type="link" onClick={() => history.push('/forgot-password')}>
                                        Solicitar nuevo enlace
                                    </Button>
                                }
                            />
                        )}

                        <Form onFinish={onFinish} layout="vertical">
                            <Form.Item
                                name="password"
                                rules={[
                                    { required: true, message: 'Ingresa tu nueva contraseña' },
                                    { min: 8, message: 'Mínimo 8 caracteres' },
                                ]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    placeholder="Nueva contraseña"
                                    autoFocus
                                />
                            </Form.Item>

                            <Form.Item
                                name="password_confirmation"
                                dependencies={['password']}
                                rules={[
                                    { required: true, message: 'Confirma tu nueva contraseña' },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve()
                                            }
                                            return Promise.reject(new Error('Las contraseñas no coinciden'))
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    placeholder="Confirmar contraseña"
                                />
                            </Form.Item>

                            <Form.Item style={{ marginBottom: '8px' }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={loading}
                                    className="green"
                                    style={{ width: '100%' }}
                                >
                                    Guardar contraseña
                                </Button>
                            </Form.Item>
                        </Form>

                        <Button
                            type="link"
                            icon={<ArrowLeftOutlined />}
                            style={{ paddingLeft: 0 }}
                            onClick={() => history.push('/')}
                        >
                            Volver al inicio de sesión
                        </Button>
                    </>
                )}
            </div>
        </div>
    )
}

export default ResetPassword
